/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления пуш-токенами устройств.
 * Используется как отдельное хранилихе пуш токенов, на первом этапе будет хранить только PWA токены
 */

/**
 * Сервис пуш-токенов устройств
 */
export class PushTokenServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения пуш-токенов.
   * Поддерживает создание и обновление.
   * Метод доступен для: admin, master, employee, owner, service, application(notification:edit).
   * Для ролей master, employee, owner можно сохранять только собственные пуш-токены.
   * Для ролей admin, service доступны все пуш-токены
   */
  PostPushToken = (req: PostPushTokenRequestDto, init?: RequestInit): Promise<PostPushTokenResponseDto> => {
    return fm.request<PostPushTokenRequestDto, PostPushTokenResponseDto>(`${this.host}/notification/api/v1/push_token`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения пуш-токенов.
   * Метод доступен для: admin, master, employee, owner, service, application(notification:read или notification:edit).
   * Для ролей master, employee, owner можно просматривать только собственные пуш-токены.
   * Для ролей admin, service доступны все пуш-токены
   */
  GetPushTokenList = (req?: GetPushTokenListRequestDto, init?: RequestInit): Promise<GetPushTokenListResponseDto[]> => {
    return fm.list<GetPushTokenListRequestDto, GetPushTokenListResponseDto>(`${this.host}/notification/api/v1/push_token/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества пуш-токенов.
   * Метод доступен для: admin, master, employee, owner, service, application(notification:read или notification:edit).
   * Для ролей master, employee, owner можно просматривать только собственные пуш-токены.
   * Для ролей admin, service доступны все пуш-токены
   */
  GetPushTokenCount = (req?: GetPushTokenCountRequestDto, init?: RequestInit): Promise<GetPushTokenCountResponseDto> => {
    return fm.request<GetPushTokenCountRequestDto, GetPushTokenCountResponseDto>(`${this.host}/notification/api/v1/push_token/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления пуш-токена.
   * Метод доступен для: admin, master, employee, owner, service, application(notification:edit).
   * Для ролей master, employee, owner можно удалять только собственные пуш-токены.
   * Для ролей admin, service можно удалять все пуш-токены
   */
  DeletePushToken = (req: DeletePushTokenRequestDto, init?: RequestInit): Promise<DeletePushTokenResponseDto> => {
    return fm.request<DeletePushTokenRequestDto, DeletePushTokenResponseDto>(`${this.host}/notification/api/v1/push_token/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления пуш-токена по идентификатору устройства пользователя.
   * Метод доступен для: admin, master, employee, owner, service, application(notification:edit).
   * Для ролей master, employee, owner можно удалять только собственные пуш-токены.
   * Для ролей admin, service можно удалять все пуш-токены
   */
  DeletePushTokenUserAppId = (req: DeletePushTokenUserAppIdRequestDto, init?: RequestInit): Promise<DeletePushTokenUserAppIdResponseDto> => {
    return fm.request<DeletePushTokenUserAppIdRequestDto, DeletePushTokenUserAppIdResponseDto>(`${this.host}/notification/api/v1/push_token/user_app_id/${encodeURIComponent(req.userAppId)}${fm.buildQuery(req, ["userAppId"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления пуш-токенов по идентификатору пользователя.
   * Метод доступен для: admin, master, employee, owner, service, application(notification:edit).
   * Для ролей master, employee, owner можно удалять только собственные пуш-токены.
   * Для ролей admin, service можно удалять все пуш-токены
   */
  DeletePushTokenUserId = (req: DeletePushTokenUserIdRequestDto, init?: RequestInit): Promise<DeletePushTokenUserIdResponseDto> => {
    return fm.request<DeletePushTokenUserIdRequestDto, DeletePushTokenUserIdResponseDto>(`${this.host}/notification/api/v1/push_token/user_id/${encodeURIComponent(req.userId)}${fm.buildQuery(req, ["userId"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочников типов пуш-токенов.
 */
export enum PushTokenType {
  /**
   * Не указан
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Для Mobile Firebase Cloud Messaging
   */
  MOBILE_FCM = "MOBILE_FCM",
  /**
   * Для Mobile Huawei Messaging System
   */
  MOBILE_HMS = "MOBILE_HMS",
  /**
   * Для Mobile Apple PushToken System для текста
   */
  MOBILE_APNS_TEXT = "MOBILE_APNS_TEXT",
  /**
   * Для Mobile Apple PushToken System для звонков
   */
  MOBILE_APNS_CALL = "MOBILE_APNS_CALL",
  /**
   * Для PWA Firebase Cloud Messaging
   */
  PWA_FCM = "PWA_FCM",
  /**
   * Для PWA Apple PushToken System
   */
  PWA_APNS = "PWA_APNS",
  /**
   * Для Mobile RuStore
   */
  MOBILE_RUSTORE = "MOBILE_RUSTORE",
}
/**
 * Справочников типов пуш-токенов.
 */
export type PushTokenTypeResponseEnum = keyof typeof PushTokenType
/**
 * Справочников типов пуш-токенов.
 */
export type PushTokenTypeRequestEnum = Exclude<PushTokenTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum PushTokenPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type PushTokenPagingDirectionTypeResponseEnum = keyof typeof PushTokenPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type PushTokenPagingDirectionTypeRequestEnum = Exclude<PushTokenPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum PushTokenPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По времени создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По времени изменения
   */
  CHANGED_AT = "CHANGED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type PushTokenPagingOrderByTypeResponseEnum = keyof typeof PushTokenPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type PushTokenPagingOrderByTypeRequestEnum = Exclude<PushTokenPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления пуш-токена
 */
export type DeletePushTokenRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id: number
}
/**
 * Ответ на запрос удаления пуш-токена
 */
export type DeletePushTokenResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeletePushTokenResponseErrorDto
}>
/**
 * Ошибка удаления пуш-токена
 */
export type DeletePushTokenResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка удаления пуш-токена
 */
export type DeletePushTokenResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос удаления пуш-токена по идентификатору устройства пользователя
 */
export type DeletePushTokenUserAppIdRequestDto = {
  /**
   * Идентификатор устройства пользователя.
   * # Тип: Guid
   */
  userAppId: string
}
/**
 * Ответ на запрос удаления пуш-токена по идентификатору устройства пользователя
 */
export type DeletePushTokenUserAppIdResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeletePushTokenUserAppIdResponseErrorDto
}>
/**
 * Ошибка удаления пуш-токена
 */
export type DeletePushTokenUserAppIdResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка удаления пуш-токена
 */
export type DeletePushTokenUserAppIdResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос удаления пуш-токенов по идентификатору пользователя
 */
export type DeletePushTokenUserIdRequestDto = {
  /**
   * Идентификатор пользователя.
   * # Диапазон: 1..2147483647
   */
  userId: number
}
/**
 * Ответ на запрос удаления пуш-токенов по идентификатору пользователя
 */
export type DeletePushTokenUserIdResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeletePushTokenUserIdResponseErrorDto
}>
/**
 * Ошибка удаления пуш-токенов
 */
export type DeletePushTokenUserIdResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка удаления пуш-токенов
 */
export type DeletePushTokenUserIdResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения количества пуш-токенов
 */
export type GetPushTokenCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: PushTokenFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества пуш-токенов
 */
export type GetPushTokenCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего пуш-токенов
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetPushTokenCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества пуш-токенов
 */
export type GetPushTokenCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   * @deprecated
   */
  readonly pushTokenFilterValidation: PushTokenFilterValidationErrorRequestDto
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества пуш-токенов
 */
export type GetPushTokenCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   * @deprecated
   */
  readonly pushTokenFilterValidation: PushTokenFilterValidationErrorResponseDto
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на получение пуш-токенов пользователя
 */
export type GetPushTokenListRequestDto = {
  /**
   * Фильтр
   */
  filter?: PushTokenFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: PushTokenPagingRequestDto
}>
/**
 * Ответ на получение списка пуш-токенов
 */
export type GetPushTokenListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пуш-токен
   */
  readonly data: PushTokenResponseDto
  /**
   * Ошибка
   */
  readonly error: GetPushTokenListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка пуш-токенов
 */
export type GetPushTokenListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   * @deprecated
   */
  readonly pushTokenFilterValidation: PushTokenFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации по страницам
   * @deprecated
   */
  readonly pushTokenPagingValidation: PushTokenPagingValidationErrorRequestDto
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка пуш-токенов
 */
export type GetPushTokenListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   * @deprecated
   */
  readonly pushTokenFilterValidation: PushTokenFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации по страницам
   * @deprecated
   */
  readonly pushTokenPagingValidation: PushTokenPagingValidationErrorResponseDto
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на создание/изменение пуш-токена
 */
export type PostPushTokenRequestDto = {
  /**
   * Пуш-токен
   */
  data: PushTokenRequestDto
}
/**
 * Ответ на запрос на создание/изменение пуш-токена
 */
export type PostPushTokenResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пуш-токен
   */
  readonly data: PushTokenResponseDto
  /**
   * Ошибка
   */
  readonly error: PostPushTokenResponseErrorDto
}>
/**
 * Ошибка запроса сохранения пуш-токена
 */
export type PostPushTokenResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации пуш-токена
   * @deprecated
   */
  readonly pushTokenValidation: PushTokenValidationErrorRequestDto
  /**
   * Ошибка сохранения пуш-токена
   */
  readonly pushTokenSaving: PushTokenSavingErrorRequestDto
  /**
   * Ошибка валидации пуш-токена
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения пуш-токена
 */
export type PostPushTokenResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации пуш-токена
   * @deprecated
   */
  readonly pushTokenValidation: PushTokenValidationErrorResponseDto
  /**
   * Ошибка сохранения пуш-токена
   */
  readonly pushTokenSaving: PushTokenSavingErrorResponseDto
  /**
   * Ошибка валидации пуш-токена
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Пуш-токен.
 * # Описание модели
 */
export type PushTokenRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id?: number
  /**
   * Тип
   */
  type: PushTokenTypeRequestEnum
  /**
   * Токен.
   * # Диапазон: 16..256
   */
  token: string
  /**
   * Идентификатор устройства пользователя.
   * # Тип: Guid
   */
  userAppId: string
  /**
   * Версия приложения.
   * # Диапазон: 3..256
   */
  appVersion: string
}
/**
 * Пуш-токен.
 * # Описание модели
 */
export type PushTokenResponseDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id: number
  /**
   * Тип
   */
  type: PushTokenTypeResponseEnum
  /**
   * Токен.
   * # Диапазон: 16..256
   */
  token: string
  /**
   * Идентификатор устройства пользователя.
   * # Тип: Guid
   */
  userAppId: string
  /**
   * Идентификатор пользователя.
   * # Диапазон: 1..2147483647
   */
  readonly userId: number | null
  /**
   * Дата и время создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly changedAt: string
  /**
   * Версия приложения.
   * # Диапазон: 3..256
   */
  appVersion: string
}
/**
 * Ошибка сохранения пуш-токена.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type PushTokenSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Идентификатор устройства пользователя уже используется
   */
  readonly userAppIdExists: PushTokenSavingErrorUserAppIdExistsRequestDto
  /**
   * Конфликт версий
   */
  readonly conflict: PushTokenSavingErrorConflictRequestDto
}>
/**
 * Ошибка сохранения пуш-токена.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type PushTokenSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Идентификатор устройства пользователя уже используется
   */
  readonly userAppIdExists: PushTokenSavingErrorUserAppIdExistsResponseDto
  /**
   * Конфликт версий
   */
  readonly conflict: PushTokenSavingErrorConflictResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type PushTokenSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type PushTokenSavingErrorConflictResponseDto = {
}
/**
 * Причины:
 *  - Переданный индентификатор устройства пользователя уже существует с другим токеном
 */
export type PushTokenSavingErrorUserAppIdExistsRequestDto = {
}
/**
 * Причины:
 *  - Переданный индентификатор устройства пользователя уже существует с другим токеном
 */
export type PushTokenSavingErrorUserAppIdExistsResponseDto = {
}
/**
 * Ошибка валидации пуш-токена.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PushTokenValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Передан некоректный идентификатор устройства пользователя
   */
  readonly userAppId: PushTokenValidationErrorUserAppIdInvalidRequestDto
}>
/**
 * Ошибка валидации пуш-токена.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PushTokenValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Передан некоректный идентификатор устройства пользователя
   */
  readonly userAppId: PushTokenValidationErrorUserAppIdInvalidResponseDto
}>
/**
 * Причины:
 * - Cодержит значение не Guid
 */
export type PushTokenValidationErrorUserAppIdInvalidRequestDto = {
}
/**
 * Причины:
 * - Cодержит значение не Guid
 */
export type PushTokenValidationErrorUserAppIdInvalidResponseDto = {
}
/**
 * Фильтр по пуш-токенам
 */
export type PushTokenFilterRequestDto = {
  /**
   * По типам пуш-токенов
   */
  types?: PushTokenTypeResponseEnum[]
  /**
   * По идентификаторам устройств пользователя.
   * # Тип: Guid
   */
  userAppIds?: string[]
  /**
   * По идентификаторам пользователя
   */
  userIds?: number[]
  /**
   * От даты создания включительно (>=)
   */
  beginCreatedAt?: string | null
  /**
   * До даты создания (<)
   */
  endCreatedAt?: string | null
  /**
   * От даты изменения включительно (>=)
   */
  beginChangedAt?: string | null
  /**
   * До даты изменения (<)
   */
  endChangedAt?: string | null
}
/**
 * Фильтр по пуш-токенам
 */
export type PushTokenFilterResponseDto = {
  /**
   * По типам пуш-токенов
   */
  types: PushTokenTypeResponseEnum[]
  /**
   * По идентификаторам устройств пользователя.
   * # Тип: Guid
   */
  userAppIds: string[]
  /**
   * По идентификаторам пользователя
   */
  userIds: number[]
  /**
   * От даты создания включительно (>=)
   */
  beginCreatedAt: string | null
  /**
   * До даты создания (<)
   */
  endCreatedAt: string | null
  /**
   * От даты изменения включительно (>=)
   */
  beginChangedAt: string | null
  /**
   * До даты изменения (<)
   */
  endChangedAt: string | null
}
/**
 * Ошибки валидации фильтра по фильтру пуш-токенов.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PushTokenFilterValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Идентификаторы устройств пользователя переданы некоректно
   */
  readonly userAppIds: PushTokenFilterValidationErrorUserAppIdsInvalidRequestDto
}>
/**
 * Ошибки валидации фильтра по фильтру пуш-токенов.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PushTokenFilterValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Идентификаторы устройств пользователя переданы некоректно
   */
  readonly userAppIds: PushTokenFilterValidationErrorUserAppIdsInvalidResponseDto
}>
/**
 * Причины:
 * - Cодержит значение не Guid
 */
export type PushTokenFilterValidationErrorUserAppIdsInvalidRequestDto = {
}
/**
 * Причины:
 * - Cодержит значение не Guid
 */
export type PushTokenFilterValidationErrorUserAppIdsInvalidResponseDto = {
}
/**
 * Постраничный вывод
 */
export type PushTokenPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ID
   */
  orderByType?: PushTokenPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: PushTokenPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type PushTokenPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ID
   */
  orderByType: PushTokenPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: PushTokenPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по пуш-токенам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PushTokenPagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: PushTokenPagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: PushTokenPagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по пуш-токенам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PushTokenPagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: PushTokenPagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: PushTokenPagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type PushTokenPagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type PushTokenPagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type PushTokenPagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type PushTokenPagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления пуш-токена
   */
  "DeletePushTokenRequest": {
    "kind": "class",
    "text": "Запрос удаления пуш-токена",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления пуш-токена
   */
  "DeletePushTokenResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления пуш-токена",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeletePushTokenResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка удаления пуш-токена
   */
  "DeletePushTokenResponse.Error": {
    "kind": "class",
    "text": "Ошибка удаления пуш-токена",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос удаления пуш-токена по идентификатору устройства пользователя
   */
  "DeletePushTokenUserAppIdRequest": {
    "kind": "class",
    "text": "Запрос удаления пуш-токена по идентификатору устройства пользователя",
    "fields": {
      /**
       * Идентификатор устройства пользователя.
       * # Тип: Guid
       */
      "userAppId": {
        "type": "string",
        "text": "Идентификатор устройства пользователя.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления пуш-токена по идентификатору устройства пользователя
   */
  "DeletePushTokenUserAppIdResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления пуш-токена по идентификатору устройства пользователя",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeletePushTokenUserAppIdResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка удаления пуш-токена
   */
  "DeletePushTokenUserAppIdResponse.Error": {
    "kind": "class",
    "text": "Ошибка удаления пуш-токена",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос удаления пуш-токенов по идентификатору пользователя
   */
  "DeletePushTokenUserIdRequest": {
    "kind": "class",
    "text": "Запрос удаления пуш-токенов по идентификатору пользователя",
    "fields": {
      /**
       * Идентификатор пользователя.
       * # Диапазон: 1..2147483647
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления пуш-токенов по идентификатору пользователя
   */
  "DeletePushTokenUserIdResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления пуш-токенов по идентификатору пользователя",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeletePushTokenUserIdResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка удаления пуш-токенов
   */
  "DeletePushTokenUserIdResponse.Error": {
    "kind": "class",
    "text": "Ошибка удаления пуш-токенов",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества пуш-токенов
   */
  "GetPushTokenCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества пуш-токенов",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PushTokenFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества пуш-токенов
   */
  "GetPushTokenCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества пуш-токенов",
    "fields": {
      /**
       * Всего пуш-токенов
       */
      "data": {
        "type": "int32",
        "text": "Всего пуш-токенов",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPushTokenCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества пуш-токенов
   */
  "GetPushTokenCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества пуш-токенов",
    "fields": {
      /**
       * Ошибка фильтрации
       * @deprecated
       */
      "pushTokenFilterValidation": {
        "type": "PushTokenFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение пуш-токенов пользователя
   */
  "GetPushTokenListRequest": {
    "kind": "class",
    "text": "Запрос на получение пуш-токенов пользователя",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PushTokenFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "PushTokenPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на получение списка пуш-токенов
   */
  "GetPushTokenListResponse": {
    "kind": "class",
    "text": "Ответ на получение списка пуш-токенов",
    "fields": {
      /**
       * Пуш-токен
       */
      "data": {
        "type": "PushToken",
        "text": "Пуш-токен",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPushTokenListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка пуш-токенов
   */
  "GetPushTokenListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка пуш-токенов",
    "fields": {
      /**
       * Ошибка фильтрации
       * @deprecated
       */
      "pushTokenFilterValidation": {
        "type": "PushTokenFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка пагинации по страницам
       * @deprecated
       */
      "pushTokenPagingValidation": {
        "type": "PushTokenPaging.ValidationError",
        "text": "Ошибка пагинации по страницам",
      },
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на создание/изменение пуш-токена
   */
  "PostPushTokenRequest": {
    "kind": "class",
    "text": "Запрос на создание/изменение пуш-токена",
    "fields": {
      /**
       * Пуш-токен
       */
      "data": {
        "type": "PushToken",
        "text": "Пуш-токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создание/изменение пуш-токена
   */
  "PostPushTokenResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создание/изменение пуш-токена",
    "fields": {
      /**
       * Пуш-токен
       */
      "data": {
        "type": "PushToken",
        "text": "Пуш-токен",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostPushTokenResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения пуш-токена
   */
  "PostPushTokenResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения пуш-токена",
    "fields": {
      /**
       * Ошибка валидации пуш-токена
       * @deprecated
       */
      "pushTokenValidation": {
        "type": "PushToken.ValidationError",
        "text": "Ошибка валидации пуш-токена",
      },
      /**
       * Ошибка сохранения пуш-токена
       */
      "pushTokenSaving": {
        "type": "PushToken.SavingError",
        "text": "Ошибка сохранения пуш-токена",
      },
      /**
       * Ошибка валидации пуш-токена
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации пуш-токена",
      },
    },
  },
  /**
   * Пуш-токен.
   * # Описание модели
   */
  "PushToken": {
    "kind": "class",
    "text": "Пуш-токен.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип
       */
      "type": {
        "type": "PushToken.Type",
        "text": "Тип",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Токен.
       * # Диапазон: 16..256
       */
      "token": {
        "type": "string",
        "text": "Токен.\n# Диапазон: 16..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 16,
            "message": "Значение не входит в допустимый диапазон. Минимум: 16"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Идентификатор устройства пользователя.
       * # Тип: Guid
       */
      "userAppId": {
        "type": "string",
        "text": "Идентификатор устройства пользователя.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор пользователя.
       * # Диапазон: 1..2147483647
       */
      "userId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор пользователя.\n# Диапазон: 1..2147483647",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Дата и время создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Версия приложения.
       * # Диапазон: 3..256
       */
      "appVersion": {
        "type": "string",
        "text": "Версия приложения.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения пуш-токена.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "PushToken.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения пуш-токена.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Идентификатор устройства пользователя уже используется
       */
      "userAppIdExists": {
        "type": "PushToken.SavingError.UserAppIdExists",
        "text": "Идентификатор устройства пользователя уже используется",
      },
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "PushToken.SavingError.Conflict",
        "text": "Конфликт версий",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "PushToken.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Причины:
   *  - Переданный индентификатор устройства пользователя уже существует с другим токеном
   */
  "PushToken.SavingError.UserAppIdExists": {
    "kind": "class",
    "text": "Причины:\n - Переданный индентификатор устройства пользователя уже существует с другим токеном",
  },
  /**
   * Ошибка валидации пуш-токена.
   * Эти проверки выполняются до обращения в базу данных
   */
  "PushToken.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации пуш-токена.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Передан некоректный идентификатор устройства пользователя
       */
      "userAppId": {
        "type": "PushToken.ValidationError.UserAppIdInvalid",
        "text": "Передан некоректный идентификатор устройства пользователя",
      },
    },
  },
  /**
   * Причины:
   * - Cодержит значение не Guid
   */
  "PushToken.ValidationError.UserAppIdInvalid": {
    "kind": "class",
    "text": "Причины:\n- Cодержит значение не Guid",
  },
  /**
   * Фильтр по пуш-токенам
   */
  "PushTokenFilter": {
    "kind": "class",
    "text": "Фильтр по пуш-токенам",
    "fields": {
      /**
       * По типам пуш-токенов
       */
      "types": {
        "type": "PushToken.Type",
        "text": "По типам пуш-токенов",
      },
      /**
       * По идентификаторам устройств пользователя.
       * # Тип: Guid
       */
      "userAppIds": {
        "type": "string",
        "text": "По идентификаторам устройств пользователя.\n# Тип: Guid",
      },
      /**
       * По идентификаторам пользователя
       */
      "userIds": {
        "type": "int32",
        "text": "По идентификаторам пользователя",
      },
      /**
       * От даты создания включительно (>=)
       */
      "beginCreatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "От даты создания включительно (>=)",
      },
      /**
       * До даты создания (<)
       */
      "endCreatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "До даты создания (<)",
      },
      /**
       * От даты изменения включительно (>=)
       */
      "beginChangedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "От даты изменения включительно (>=)",
      },
      /**
       * До даты изменения (<)
       */
      "endChangedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "До даты изменения (<)",
      },
    },
  },
  /**
   * Ошибки валидации фильтра по фильтру пуш-токенов.
   * Эти проверки выполняются до обращения в базу данных
   */
  "PushTokenFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации фильтра по фильтру пуш-токенов.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Идентификаторы устройств пользователя переданы некоректно
       */
      "userAppIds": {
        "type": "PushTokenFilter.ValidationError.UserAppIdsInvalid",
        "text": "Идентификаторы устройств пользователя переданы некоректно",
      },
    },
  },
  /**
   * Причины:
   * - Cодержит значение не Guid
   */
  "PushTokenFilter.ValidationError.UserAppIdsInvalid": {
    "kind": "class",
    "text": "Причины:\n- Cодержит значение не Guid",
  },
  /**
   * Постраничный вывод
   */
  "PushTokenPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: ID
       */
      "orderByType": {
        "type": "PushTokenPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "PushTokenPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по пуш-токенам.
   * Эти проверки выполняются до обращения в базу данных
   */
  "PushTokenPaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по пуш-токенам.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "PushTokenPaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "PushTokenPaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "PushTokenPaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "PushTokenPaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочников типов пуш-токенов.
   */
  "PushToken.Type": {
    "kind": "enum",
    "text": "Справочников типов пуш-токенов.",
    "values": {
      /**
       * Не указан
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Не указан",
      },
      /**
       * Для Mobile Firebase Cloud Messaging
       */
      "MOBILE_FCM": {
        "i": 1,
        "text": "Для Mobile Firebase Cloud Messaging",
      },
      /**
       * Для Mobile Huawei Messaging System
       */
      "MOBILE_HMS": {
        "i": 2,
        "text": "Для Mobile Huawei Messaging System",
      },
      /**
       * Для Mobile Apple PushToken System для текста
       */
      "MOBILE_APNS_TEXT": {
        "i": 3,
        "text": "Для Mobile Apple PushToken System для текста",
      },
      /**
       * Для Mobile Apple PushToken System для звонков
       */
      "MOBILE_APNS_CALL": {
        "i": 4,
        "text": "Для Mobile Apple PushToken System для звонков",
      },
      /**
       * Для PWA Firebase Cloud Messaging
       */
      "PWA_FCM": {
        "i": 5,
        "text": "Для PWA Firebase Cloud Messaging",
      },
      /**
       * Для PWA Apple PushToken System
       */
      "PWA_APNS": {
        "i": 6,
        "text": "Для PWA Apple PushToken System",
      },
      /**
       * Для Mobile RuStore
       */
      "MOBILE_RUSTORE": {
        "i": 7,
        "text": "Для Mobile RuStore",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "PushTokenPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "PushTokenPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По времени создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "По времени создания",
      },
      /**
       * По времени изменения
       */
      "CHANGED_AT": {
        "i": 3,
        "text": "По времени изменения",
      },
    },
  },
}